import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pagesPicker.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent } from "../../util/pubsub/pubsub";
class PagesPicker extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.pageRefUser = void 0;
    this.documentLoaded = false;
    this.thumbNailsPanel = void 0;
    this.$pickerDialog = void 0;
    this.pdfDoc = void 0;
    this.pageRotationInfo = void 0;
    this.previousSelectedPageNum = void 0;
    this.curSelection = void 0;
    this.maxPages = void 0;
    this.$selectedRangeEle = void 0;
    this.$pageSelectionAllRadio = void 0;
    this.$pageSelectionOddRadio = void 0;
    this.$pageSelectionEvenRadio = void 0;
    this.thumbnailList = [];
    this.canvasSizes = {
      "Small": 0.5,
      "Medium": 1,
      "Large": 2
    };
    //stores rotation characters for 0 deg, 90 deg, 180 deg, 270 deg
    this.rotationDegreeToRotationCode = {
      0: "",
      90: "r",
      180: "u",
      270: "c"
    };
  }
  connectedCallback() {
    // do stuff here
  }
  renderedCallback() {
    console.log("PagePicker: renderedCallback called. pageRefUser = ", this.pageRefUser);
    const self = this;
    if (!this.documentLoaded) {
      this.documentLoaded = true;
      __g_pdfDoc___.getData().then(async function (pdfBytes) {
        const loadingTask = pdfjsLib.getDocument(pdfBytes);
        loadingTask.promise.then(function (doc) {
          self.renderThumbnails(doc);
        }).catch(error => console.error("Exception while loading PDF: " + error.message));
      });
    }
    if (!this.thumbNailsPanel) {
      this.thumbNailsPanel = this.template.querySelector('.pagesThumbnails');
      console.log("thumbNailsPanel = ", this.thumbNailsPanel);
    }
    // For some reason, the template.querySelector() function is failing any time it is called except for here.
    // Gather all of dom elements here.
    if (!this.$selectedRangeEle) {
      this.$selectedRangeEle = $(this.template.querySelector(".selectedRange"));
      this.$selectedRangeEle.val("1");
      this.$pageSelectionAllRadio = $(this.template.querySelector(".pageSelectionAll"));
      this.$pageSelectionAllRadio.change(evt => {
        self.selectAllPages();
      });
      this.$pageSelectionOddRadio = $(this.template.querySelector(".pageSelectionOdd"));
      this.$pageSelectionOddRadio.change(evt => {
        self.selectOddPages();
      });
      this.$pageSelectionEvenRadio = $(this.template.querySelector(".pageSelectionEven"));
      this.$pageSelectionEvenRadio.change(evt => {
        self.selectEvenPages();
      });
    }
    if (!this.$pickerDialog) {
      this.$pickerDialog = $(this.template.querySelector(".pagesPickerContent")).dialog({
        autoOpen: true,
        modal: true,
        width: 600,
        buttons: {
          "Ok": {
            text: 'Ok',
            click: function () {
              $(this).dialog("close");
              const pageRef = {
                attributes: {
                  "component": "zpaper-pages-picker",
                  "user": self.pageRefUser
                }
              };
              // ToDo: add any rotation code to page range...
              const pageRange = self.$selectedRangeEle.val().split(',').map((pgNum, idx) => pgNum + self.rotationDegreeToRotationCode[self.pageRotationInfo[pgNum - 1]]).join(",");
              const event = new CustomEvent(eventTypes.COMPONENT_COMMUNICATION, {
                detail: {
                  selectedPages: pageRange
                },
                bubbles: true,
                cancelable: true
              });
              console.log("Sending event: ", event);
              fireEvent(pageRef, eventTypes.COMPONENT_COMMUNICATION, event);
            }
          },
          "Cancel": {
            text: 'Cancel',
            click: function () {
              $(this).dialog("close");
              // Let our listener know that no pages were selected.
              const event = new CustomEvent(eventTypes.COMPONENT_COMMUNICATION, {
                detail: {
                  selectedPages: ''
                },
                bubbles: true,
                cancelable: true
              });
              console.log("Sending event: ", event);
              fireEvent(pageRef, eventTypes.COMPONENT_COMMUNICATION, event);
            }
          }
        }
      });
    }
  }
  renderThumbnails(doc) {
    const self = this;
    this.pdfDoc = doc;
    this.maxPages = doc.numPages;
    this.curSelection = `1-${this.maxPages}`;
    this.previousSelectedPageNum = 1;
    console.log("Number of pages in document = " + this.maxPages);
    let pages = [];
    this.pageRotationInfo = [];
    for (let i = 1; i <= doc.numPages; i++) {
      pages.push(pages.length + 1);
    }
    return Promise.all(pages.map(function (i) {
      const thumbNailDiv = document.createElement("div");
      thumbNailDiv.className = "thumbnail";
      thumbNailDiv.style.padding = "2px";
      self.thumbNailsPanel.appendChild(thumbNailDiv);
      doc.getPage(i).then(function (page) {
        const rotation = __g__allPageRotation && __g__allPageRotation.length > 0 ? __g__allPageRotation[i - 1] : self.pageRotationInfo[i - 1] || page.rotate || 0;
        thumbNailDiv.style.width = 90 === page.rotate || 270 === page.rotate ? "88px" : "113px";
        const vp = page.getViewport(1);
        self.pageRotationInfo.push(rotation);
        let canvas = document.createElement("canvas");
        canvas.className = (1 === i ? "currently-selected " : "notselected ") + "thumbCanvas";
        // keep 8.5 x 11 aspect ratio
        // canvas.width = 90 === rotation || 270 === rotation ? 109 : 84;
        // canvas.height = 90 === rotation || 270 === rotation ? 84 : 109;

        let scale = 0;
        if (rotation === 0 || rotation === 180) {
          //vertical canvas layout
          canvas.height = vp.width < vp.height ? 109 : 84;
          canvas.width = vp.width < vp.height ? 84 : 109;
          scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
          console.log(`AHS240613 (vertical): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
        } else {
          //horizontal canvas layout
          canvas.width = vp.width < vp.height ? 109 : 84;
          canvas.height = vp.width < vp.height ? 84 : 109;
          scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
          console.log(`AHS240613 (horizontal): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
        }
        canvas.idx = i;
        canvas.id = 'canvas_' + i;
        canvas.setAttribute('data-id', 'canvas_' + i);
        canvas.addEventListener("click", function (evt) {
          self.pageClicked(evt, canvas);
        });
        self.thumbnailList.push(canvas);

        // const scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
        return page.render({
          canvasContext: canvas.getContext("2d"),
          viewport: page.getViewport(scale, rotation)
        }).promise.then(function () {
          return canvas;
        });
      }).then(function (canvas) {
        thumbNailDiv.appendChild(canvas);
        self.appendActionsToThumbnail(thumbNailDiv, canvas.idx);
        if (canvas.idx === self.maxPages) {
          //CRN241016 Initialize the dialog with all thumbnails selected.
          self.selectAllPages();
        }
      }).catch(error => console.log("Exception while loading PDF: " + error.message));
    }));
  }
  pageClicked(evt, ele) {
    // uncheck all radio buttons
    this.$pageSelectionAllRadio.prop("checked", false);
    this.$pageSelectionOddRadio.prop("checked", false);
    this.$pageSelectionEvenRadio.prop("checked", false);
    let curSelection = this.$selectedRangeEle.val();
    if (evt) {
      if (evt.ctrlKey || evt.metaKey) {
        //AHS250210 - Handle ctrlKey (Windows) or metaKey (Mac) for multi-select behavior
        curSelection = this.addOrRemoveSelectionPage(curSelection, ele.idx, !ele.classList.contains('currently-selected'));
        $(ele).toggleClass("currently-selected notselected");
      } else if (evt.shiftKey) {
        // Handle shift key for selecting a range of pages
        const lastSelectedPage = this.previousSelectedPageNum;
        curSelection = "";
        if (lastSelectedPage > 0) {
          let curPage = ele.idx;
          const beginPage = Math.min(curPage, lastSelectedPage);
          const endPage = Math.max(curPage, lastSelectedPage);
          this.clearSelection();
          for (let i = beginPage - 1; i < endPage; i++) {
            this.selectEle(this.thumbnailList[i]);
            if (curSelection.length > 0) {
              curSelection += ',';
            }
            curSelection += i + 1;
          }
        } else {
          // There was no previous selection.
          this.selectEle(ele);
          curSelection = ele.idx;
        }
      } else {
        // Handle simple click (without any ctrl / meta / shift  key press)
        this.clearSelection(); // Clear out the previous selection.
        curSelection = ele.idx;
        this.selectEle(ele);
      }
    }
    this.previousSelectedPageNum = ele.idx;
    this.$selectedRangeEle.val(curSelection);
  }
  selectAllPages() {
    let curSelection = "";
    for (let i = 0; i < this.thumbnailList.length; i++) {
      this.selectEle(this.thumbnailList[i]);
      if (curSelection.length > 0) {
        curSelection += ',';
      }
      curSelection += i + 1;
    }
    this.$selectedRangeEle.val(curSelection);
  }
  selectOddPages() {
    let curSelection = "";
    this.clearSelection();
    for (let i = 0; i < this.thumbnailList.length; i += 2) {
      this.selectEle(this.thumbnailList[i]);
      if (curSelection.length > 0) {
        curSelection += ',';
      }
      curSelection += i + 1;
    }
    this.$selectedRangeEle.val(curSelection);
  }
  selectEvenPages() {
    let curSelection = "";
    this.clearSelection();
    for (let i = 1; i < this.thumbnailList.length; i += 2) {
      this.selectEle(this.thumbnailList[i]);
      if (curSelection.length > 0) {
        curSelection += ',';
      }
      curSelection += i + 1;
    }
    this.$selectedRangeEle.val(curSelection);
  }
  clearSelection() {
    for (let i = 0; i < this.thumbnailList.length; i++) {
      this.deselectEle(this.thumbnailList[i]);
    }
  }
  deselectEle(ele) {
    if (ele.classList.contains("currently-selected")) {
      ele.classList.remove("currently-selected");
    }
    if (!ele.classList.contains("notselected")) {
      ele.classList.add("notselected");
    }
  }
  selectEle(ele) {
    if (!ele.classList.contains("currently-selected")) {
      ele.classList.add("currently-selected");
    }
    if (ele.classList.contains("notselected")) {
      ele.classList.remove("notselected");
    }
  }
  addOrRemoveSelectionPage(selection, pageNumber, add) {
    console.log((add ? "Adding " : "Removing ") + pageNumber + " from/to selection: " + selection);
    // Make sure we are comparing string to string in our filter below.
    pageNumber = pageNumber + "";
    // We'll always first remove the number from the selection.
    let newSelection = selection.split(',').filter(val => val.trim() !== pageNumber).join(',');
    if (add) {
      if (newSelection.length > 0) {
        newSelection += ',';
      }
      newSelection += pageNumber;
    }
    console.log("Returning new selection: " + newSelection);
    return newSelection;
  }
  appendActionsToThumbnail(thumbnail, canvasIndex) {
    let self = this;
    let actionsDiv = thumbnail.querySelector(".actions");
    if (!actionsDiv) {
      actionsDiv = document.createElement("div");
      actionsDiv.setAttribute("class", "actions");
      actionsDiv.style.marginTop = "3px";

      //refresh icon
      let refreshButton = document.createElement("span");
      refreshButton.innerHTML = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 496.156 496.156" style="enable-background:new 0 0 496.156 496.156;" xml:space="preserve" width="18px" height="18px">                <g>                    <path style="fill:#000000;" d="M428.243,172.149c-10.348,0.023-20.694,0.054-31.042,0.077                        c-23.272-52.177-68.95-89.871-126.649-98.91c-64.287-10.071-125.816,19.788-162.504,72.312                        c-16.296,23.326,22.003,45.165,38.16,22.034c50.317-72.037,157.757-65.527,201.907,4.686c-9.559,0.022-19.118,0.046-28.678,0.068                        c-2.674,0.008-4.574,1.197-5.749,2.877c-1.92,2.058-2.65,5.072-0.639,8.186c18.204,28.25,36.408,56.499,54.616,84.745                        c3.061,4.747,9.663,4.708,12.696-0.046c18.062-28.338,36.126-56.675,54.188-85.013C437.538,178.48,433.602,172.135,428.243,172.149                        z"></path>                    <path style="fill:#000000;" d="M350.353,327.224c-49.927,71.49-156.108,65.63-200.886-3.049c9.161-0.022,18.322-0.046,27.484-0.068                        c2.666-0.008,4.563-1.19,5.741-2.865c1.924-2.059,2.658-5.072,0.646-8.197c-18.2-28.246-36.405-56.499-54.609-84.741                        c-3.056-4.751-9.662-4.712-12.695,0.046c-18.063,28.334-36.13,56.671-54.196,85.009c-2.987,4.689,0.948,11.032,6.308,11.017                        c10.669-0.027,21.337-0.054,32.006-0.08c23.498,51.319,68.777,88.332,125.865,97.275c64.287,10.072,125.816-19.784,162.496-72.312                        C404.806,325.928,366.508,304.09,350.353,327.224z"></path></g></svg>';
      refreshButton.addEventListener("click", event => {
        /*
         * index passed to rotateSpecificPage function should be starting from 0
         * canvas idx (canvasIndex) begins from 1
         * subtract 1 from canvas idx when passing to
         **/
        self.rotateSpecificPage(canvasIndex - 1);
      });
      actionsDiv.appendChild(refreshButton);

      //page number
      let pageNumber = document.createElement("span");
      pageNumber.innerHTML = canvasIndex;
      //pageNumber.style = "padding-left: 25%;";
      pageNumber.setAttribute('class', 'pageNumber');
      //pageNumber.style = "margin-left: auto; margin-right: auto;";
      actionsDiv.appendChild(pageNumber);
      thumbnail.appendChild(actionsDiv);
    }
    return actionsDiv;
  }
  rotateSpecificPage(indexOfPageToRotate) {
    const thumbnailToRotate = this.thumbnailList[indexOfPageToRotate];

    //rotate thumbnail function will fire the SHOW_PDF_PAGE event
    this.rotateThumbnail(thumbnailToRotate, indexOfPageToRotate);
    this.clearSelection();
  }
  rotateThumbnail(thumbnail, thumbnailIndex) {
    const self = this;
    const canvas = thumbnail;
    thumbnail = canvas.parentNode;
    thumbnail.removeChild(canvas);
    this.pageRotationInfo[thumbnailIndex] = this.addRotation(this.pageRotationInfo[thumbnailIndex]);
    this.pdfDoc.getPage(thumbnailIndex + 1).then(page => self.renderThumbnail(page, thumbnailIndex + 1)) //, currentSelectionArr
    .then(canvas => {
      //outer variables not accessible here, refetch the thumnbail for current canvas based on canvas index
      //canvas index starts from 1, subtract from canvas index to get right thumbnail.
      // let thumbnail = self.thumbnailList[canvas.idx - 1].parentNode;
      let actionsDiv = thumbnail.querySelector(".actions");
      if (!actionsDiv) {
        actionsDiv = self.appendActionsToThumbnail(thumbnail, canvas.idx);
      }
      self.thumbnailList[thumbnailIndex] = canvas; // replace in our list
      thumbnail.insertBefore(canvas, actionsDiv);
    });
  }
  addRotation(currentRotation) {
    return (currentRotation + 90) % 360;
  }
  renderThumbnail(page, pageNumber) {
    const self = this;
    let rotation = this.pageRotationInfo[pageNumber - 1] || 0;
    const vp = page.getViewport(1);
    const originalPageRotation = vp.rotation;
    const canvas = document.createElement("canvas");
    canvas.className = (1 === pageNumber ? "currently-selected" : "notselected") + " thumbCanvas";
    let scale = 0;
    if (rotation === 0 || rotation === 180) {
      //vertical canvas layout
      const canvasSize = self.thumbnailSize ? self.canvasSizes[self.thumbnailSize] : self.canvasSizes.Medium;
      canvas.height = vp.width < vp.height ? 109 * canvasSize : 84 * canvasSize;
      canvas.width = vp.width < vp.height ? 84 * canvasSize : 109 * canvasSize;
      scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
      if (originalPageRotation === 90 || originalPageRotation === 270) {
        scale = Math.min(canvas.width / vp.height, canvas.height / vp.width);
      }
    } else {
      //horizontal canvas layout
      const canvasSize = self.thumbnailSize ? self.canvasSizes[self.thumbnailSize] : self.canvasSizes.Medium;
      canvas.width = vp.width < vp.height ? 109 * canvasSize : 84 * canvasSize;
      canvas.height = vp.width < vp.height ? 84 * canvasSize : 109 * canvasSize;
      canvas.style = "margin-bottom: " + 12.5 * canvasSize + "px; margin-top:  " + 12.5 * canvasSize + "px;";
      scale = Math.min(canvas.width / vp.height, canvas.height / vp.width); //AHS240613 / ORV240614
      if (originalPageRotation === 90 || originalPageRotation === 270) {
        scale = Math.min(canvas.width / vp.width, canvas.height / vp.height); //AHS240613 / ORV240614
      }
    }
    canvas.idx = pageNumber;
    canvas.id = 'canvas_' + pageNumber;
    canvas.setAttribute('data-id', 'canvas_' + pageNumber);
    canvas.addEventListener("click", function (evt) {
      self.pageClicked(evt, this);
    });
    return page.render({
      canvasContext: canvas.getContext("2d"),
      viewport: page.getViewport(scale, rotation)
    }).promise.then(function () {
      return canvas;
    });
  }
}
_registerDecorators(PagesPicker, {
  publicProps: {
    pageRefUser: {
      config: 0
    }
  },
  fields: ["documentLoaded", "thumbNailsPanel", "$pickerDialog", "pdfDoc", "pageRotationInfo", "previousSelectedPageNum", "curSelection", "maxPages", "$selectedRangeEle", "$pageSelectionAllRadio", "$pageSelectionOddRadio", "$pageSelectionEvenRadio", "thumbnailList", "canvasSizes", "rotationDegreeToRotationCode"]
});
export default _registerComponent(PagesPicker, {
  tmpl: _tmpl
});